export const initSolutionSection = (): void => {
  const section = document.getElementById('notre-solution');
  const dynamicImage = document.getElementById('dynamic-image') as HTMLImageElement | null;
  const badgeText = document.querySelector('.solution-preview__badge-text');

  if (!section || !dynamicImage) return;

  const isMobile = () => window.innerWidth < 768;

  // Fonction pour activer une carte
  const activateCard = (card: HTMLElement) => {
    const imagePath = card.getAttribute('data-image');
    const featureName = card.getAttribute('data-feature-name');

    if (!imagePath) return;

    // Ne pas recharger si c'est déjà la même image
    if (dynamicImage.src.endsWith(imagePath)) return;

    // Retirer active de toutes les cartes
    section.querySelectorAll('.solution-card').forEach(c => c.classList.remove('active'));

    // Activer la carte courante
    card.classList.add('active');

    // Changer l'image. Seul le visuel initial a des variantes de taille : sans ce retrait,
    // srcset continuerait d'afficher le tableau de bord quel que soit src.
    dynamicImage.removeAttribute('srcset');
    dynamicImage.removeAttribute('sizes');
    dynamicImage.src = imagePath;

    // Mettre à jour le badge
    if (badgeText && featureName) {
      badgeText.textContent = featureName;
    }
  };

  // DÉLÉGATION D'ÉVÉNEMENTS sur le conteneur - utilise mouseover qui bubble
  section.addEventListener('mouseover', (e) => {
    if (isMobile()) return;

    const card = (e.target as HTMLElement).closest('.solution-card') as HTMLElement;
    if (card && card.getAttribute('data-image')) {
      activateCard(card);
    }
  });

  // Click pour mobile et desktop
  section.addEventListener('click', (e) => {
    const card = (e.target as HTMLElement).closest('.solution-card') as HTMLElement;
    if (card && card.getAttribute('data-image')) {
      activateCard(card);
    }
  });
};
